import { Component, Input } from '@angular/core';
import { Tag } from '@app/shared/models/tag.interface';

@Component({
  selector: 'app-tag-icon',
  imports: [],
  templateUrl: './tag-icon.component.html',
  styleUrl: './tag-icon.component.scss'
})
export class TagIconComponent {
  @Input() tag: Tag;
  @Input() inverse: boolean;

  get inverseClass(): string {
    if (this.inverse) {
      return 'or-inverse';
    }
  }
}
